var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.storyblokEnabled)?_c('header-white',{class:{ 'modal-opened': _vm.modal.isModalOpened }}):_c('storyblok-header',{class:{ 'modal-opened': _vm.modal.isModalOpened }})}
var staticRenderFns = []

export { render, staticRenderFns }